import { Button, timestampFormatter } from '@retainerclub/common';
import PropTypes from 'prop-types';

function DashboardSchedulesTableRow({ schedule, handleOpenModal }) {
  return (
    <tr>
      <td className="flex w-full flex-col justify-start gap-4 py-8 pr-3 pl-4 font-medium text-gray-900 text-sm sm:w-auto sm:max-w-none sm:flex-row sm:items-center sm:pl-0">
        <div>
          {schedule.patient.firstName} {schedule.patient.lastName}
          <dl className="font-normal lg:hidden">
            <dt className="sr-only sm:hidden">When&apos;s it being made?</dt>
            <dd className="mt-1 truncate text-gray-500 sm:hidden">
              <span className="font-medium text-gray-600">
                {timestampFormatter(schedule.expectedShippedAt, false)}
              </span>
            </dd>
          </dl>
        </div>
      </td>
      <td className="hidden px-3 py-8 text-gray-500 text-sm sm:table-cell">
        <span className="font-medium text-gray-600">
          {timestampFormatter(schedule.expectedShippedAt, false)}
        </span>
      </td>
      <td className="py-8 pr-4 pl-3 text-right font-medium text-sm sm:pr-0">
        <Button
          size="sm"
          color="rcprimary"
          name="Manage"
          rounded
          disabled // TODO: make the modal live based on inactiveStates
          onClick={() => handleOpenModal(schedule)}
        />
      </td>
    </tr>
  );
}

DashboardSchedulesTableRow.propTypes = {
  schedule: PropTypes.object.isRequired,
  handleOpenModal: PropTypes.func.isRequired,
};

export default DashboardSchedulesTableRow;
